import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ResultColumn from './ResultColumn';
import Run from '../../types/run';
import style from './result.module.css';
import { formatDate, sortByOrder } from '../../utils/utils';
import { Stack } from '@mui/material';



const Results = ({ runs }: { runs: Run[] }) => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));

  const [selectedDate] = useState(formatDate(new Date()));

  const showResult = () => {
    const sortedRuns = runs.sort(sortByOrder); // Just in case
    return sortedRuns?.map(({ selectedGame, includesHit, splitHit, clip, partial, startSplit, endSplit, order, date }: Run) =>
    (<ResultColumn
      key={`resultcolumn${date}-${order}`}
      selectedGame={selectedGame}
      includesHit={includesHit}
      splitHit={splitHit}
      clip={clip}
      date={selectedDate}
      order={order}
      partial={partial}
      startSplit={startSplit}
      endSplit={endSplit}/>));
  }

  if (runs && runs.length > 0) {
    return (
      <>
        
        <Stack direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'column', xl: 'row' }}>
          {
            showResult()
          }
        </Stack>
      </>);
  }
  return (
    <>
      loading data
    </>
  )
};
export default Results;
